<template>
    <v-card flat>
        <v-card-title v-if="hasTitle">
            {{ title }}
            <slot name="title" />
        </v-card-title>
        <v-card-text>
            <slot />
        </v-card-text>
        <v-card-actions v-if="hasActions">
            <slot name="actions" />
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: {
        title: String,
        hasTitle: { type: Boolean, default: false },
        hasActions: { type: Boolean, default: false },
    },
};
</script>

<style></style>
